import React from 'react'
import { Button, Dropdown } from 'antd'
import {
    AlignLeftOutlined,
    AppstoreOutlined,
    BookOutlined,
    CodeOutlined,
    DownOutlined,
    TableOutlined,
    UploadOutlined,
} from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '../../../store/reducers/authorized-layout.reducer'
import CreateProblemSetModal from '../../../pages/resources/problem-sets/CreateProblemSetModal'
import { toggleCreateProblemSetModal } from '../../../store/slices/problem-sets.slice'
import CreateTextAssignmentModal from '../../../pages/resources/assignments/components/modals/create/text/CreateTextAssignmentModal'
import {
    toggleCreateComputerScienceAssignmentModal,
    toggleCreateTextAssignmentModal,
    toggleImportModelModal,
} from '../../../store/slices/assignment.slice'
import ImportModelModal from '../../../pages/resources/assignments/components/modals/create/import-model/ImportModelModal'
import CreateExcelAssignmentModal from '../../../pages/resources/assignments/components/modals/create/excel/CreateExcelAssignmentModal'
import CreateComputerScienceAssignmentModal from '../../../pages/resources/assignments/components/modals/create/computer-science/CreateComputerScienceAssignmentModal'
import userSelectors from '../../../store/selectors/user.selectors'
import { useIsSenseUserOrImpersonated } from '../../../hooks/useIsSenseUserOrImpersonated'

const CreateResourceDropdown = () => {
    const dispatch = useDispatch()
    const showCreateComputerScienceAssignmentModal = useSelector(
        state => state.assignmentSlice.showCreateComputerScienceAssignmentModal,
    )
    const showCreateExcelAssignmentModal = useSelector(state => state.authorizedLayout.showCreateExcelAssignmentModal)
    const showCreateProblemSetModal = useSelector(state => state.problemSets.showCreateProblemSetModal)
    const showCreateTextAssignmentModal = useSelector(state => state.assignmentSlice.showCreateTextAssignmentModal)
    const showImportModelModal = useSelector(state => state.assignmentSlice.showImportModelModal)
    const isShopUser = useSelector(userSelectors.isShopUser)
    const importAvailable = useIsSenseUserOrImpersonated()
    const createMenuItems = [
        {
            // first item here should have no children because autoFocus will not work
            key: 'problemSet',
            label: 'Problem set',
            icon: <AppstoreOutlined aria-hidden='true' />,
            onClick: () => dispatch(toggleCreateProblemSetModal()),
        },
        ...(isShopUser
            ? []
            : [
                  {
                      key: 'assignment',
                      label: 'Assignment',
                      icon: <BookOutlined aria-hidden='true' />,
                      children: [
                          {
                              key: 'cs',
                              label: 'Computer Science',
                              icon: <CodeOutlined aria-hidden='true' />,
                              onClick: () => dispatch(toggleCreateComputerScienceAssignmentModal()),
                          },
                          {
                              key: 'text',
                              label: 'Text',
                              icon: <AlignLeftOutlined aria-hidden='true' />,
                              onClick: () => dispatch(toggleCreateTextAssignmentModal()),
                          },
                          {
                              key: 'excel',
                              label: 'Excel',
                              icon: <TableOutlined aria-hidden='true' />,
                              onClick: () => dispatch(actions.setShowCreateExcelAssignmentModal(true)),
                          },
                      ],
                  },
                  ...(importAvailable
                      ? [
                            {
                                key: 'import',
                                label: 'Import',
                                icon: <UploadOutlined aria-hidden='true' />,
                                onClick: () => dispatch(toggleImportModelModal()),
                            },
                        ]
                      : []),
              ]),
    ]

    return (
        <>
            <Dropdown
                menu={{ items: createMenuItems, triggerSubMenuAction: 'click' }}
                autoFocus
                trigger={['click']}
                destroyPopupOnHide
                getPopupContainer={() => document.getElementById('site-layout-header')}
            >
                <Button type='primary' size='large'>
                    Create <DownOutlined aria-hidden />
                </Button>
            </Dropdown>
            {showCreateComputerScienceAssignmentModal && <CreateComputerScienceAssignmentModal />}
            {showCreateExcelAssignmentModal && <CreateExcelAssignmentModal />}
            {showCreateProblemSetModal && <CreateProblemSetModal />}
            {showCreateTextAssignmentModal && <CreateTextAssignmentModal />}
            {showImportModelModal && <ImportModelModal />}
        </>
    )
}

export default CreateResourceDropdown
